import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { width: 8, height: 1, viewBox: "0 0 8 1", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 0.5C7.5 0.776142 7.27614 1 7 1L1 1C0.723857 1 0.5 0.776142 0.5 0.5C0.5 0.223858 0.723857 0 1 0L7 0C7.27614 0 7.5 0.223858 7.5 0.5Z" }));
export {
  l as default
};
//# sourceMappingURL=index.es2394.js.map
